import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="charity-care-application-forms"
export default class extends Controller {
  setActiveElement(e) {
    this.activeElement = e.target;
  }

  fillInfo(e) {
    var value = e.target.dataset['value'];
    var pageNumber = e.target.dataset['pageNumber'];
    var originalLabelLeft = e.target.dataset['originalLabelLeft'];
    var originalLabelTop = e.target.dataset['originalLabelTop'];
    var originalLabelWidth = e.target.dataset['originalLabelWidth'];
    var originalLabelHeight = e.target.dataset['originalLabelHeight'];

    if (this.activeElement) {
      // In some cases the active element is the :original_label input for the field, in which cases we also want
      // to capture the page number and left/top coordinates, so we can display the highlight.
      // In other cases the active element is a "sub-label" for one of the coordinates (e.g. for PICK_ONE or for
      // PICK_ANY), in which case we don't store those additional details.
      this.activeElement.value = value;
      if (this.activeElement.id == "charity_care_application_field_original_label") {
        this.activeElement.parentElement.querySelector("#charity_care_application_field_page_number").value = pageNumber;
        this.activeElement.parentElement.querySelector("#charity_care_application_field_original_label_left").value = originalLabelLeft;
        this.activeElement.parentElement.querySelector("#charity_care_application_field_original_label_top").value = originalLabelTop;
        this.activeElement.parentElement.querySelector("#charity_care_application_field_original_label_width").value = originalLabelWidth;
        this.activeElement.parentElement.querySelector("#charity_care_application_field_original_label_height").value = originalLabelHeight;
      }

      // Move the focus to the next field
      if (this.activeElement.parentElement.nextElementSibling) {
        this.activeElement = this.activeElement.parentElement.nextElementSibling.querySelector("input");
      }
    } else {
      var addFieldForm = document.getElementById("add-field-form");
      addFieldForm.querySelector("#charity_care_application_field_original_label").value = value;
      addFieldForm.querySelector("#charity_care_application_field_page_number").value = pageNumber;
      addFieldForm.querySelector("#charity_care_application_field_original_label_left").value = originalLabelLeft;
      addFieldForm.querySelector("#charity_care_application_field_original_label_top").value = originalLabelTop;
      addFieldForm.querySelector("#charity_care_application_field_original_label_width").value = originalLabelWidth;
      addFieldForm.querySelector("#charity_care_application_field_original_label_height").value = originalLabelHeight;
    }
  }
}
